import type {
  PlacePredictionDto,
  PlacesAutocompleteResponseDto,
  PlacesGeocodeResponseDto,
} from './places.dto';

export type GeocodeMatch = {
  /** Google's guess at a near name rather than this one. */
  partialMatch: boolean;
  lat?: number;
  lng?: number;
};

export type GeocodeResult = { status: PlacesGeocodeResponseDto['status']; matches: GeocodeMatch[] };

export const mapPredictions = (data: PlacesAutocompleteResponseDto): PlacePredictionDto[] =>
  (data?.suggestions ?? []).flatMap(({ placePrediction }) =>
    placePrediction ? [placePrediction] : [],
  );

export const mapGeocode = (data: PlacesGeocodeResponseDto): GeocodeResult => ({
  status: data.status,
  matches: (data.results ?? []).map(({ partial_match, geometry }) => ({
    partialMatch: !!partial_match,
    lat: geometry?.location?.lat,
    lng: geometry?.location?.lng,
  })),
});
